export default __webpack_public_path__ + "static/media/coin_4gms.10af615c.jpg";